export const classicWidget = {
  userDetails: {
    id: 123,
    badge: '/images/icons/badge-copy.png',
    name: 'Domnic Harris',
    profile_pic: 'https://via.placeholder.com/150x150',
    job_title: 'Co-Founder & CEO',
    bio: 'Nam imperdiet ornare enim ac tempor Suspendisse ac accumsan orci jomnic dr neva ketoli respecotra domeko... ',
    stats: {
      followers: 455,
      courses: 17,
      following: 45,
    },
  },
  simpleCard: {
    media: 'https://via.placeholder.com/461x240',
    title: 'Cafe Basilico',
    subTitle: 'Italian Cafe',
    rating: 4.5,
    reviews: 52,
    availabilities: ['7:30 PM', '9:00 PM'],
  },
  userStatistics: {
    labelIncome: 'income',
    labelExpence: 'Expence',
    chartData: [
      { month: 'Jan', income: 500, expence: 500 },
      { month: 'Feb', income: 700, expence: 750 },
      { month: 'Mar', income: 900, expence: 1200 },
      { month: 'Apr', income: 1000, expence: 1350 },
      { month: 'May', income: 945, expence: 1400 },
      { month: 'Jun', income: 1100, expence: 1200 },
      { month: 'Jul', income: 1250, expence: 1000 },
      { month: 'Aug', income: 1400, expence: 500 },
      { month: 'Sep', income: 1120, expence: 500 },
      { month: 'Oct', income: 1030, expence: 500 },
      { month: 'Nov', income: 1150, expence: 500 },
      { month: 'Dec', income: 1500, expence: 500 },
    ],
  },
  orders: [
    { month: 'Jan', orders: 10 },
    { month: 'Feb', orders: 60 },
    { month: 'Mar', orders: 120 },
    { month: 'Apr', orders: 200 },
    { month: 'May', orders: 220 },
    { month: 'Jun', orders: 300 },
    { month: 'Jul', orders: 330 },
    { month: 'Aug', orders: 300 },
    { month: 'Sep', orders: 230 },
    { month: 'Oct', orders: 210 },
    { month: 'Nov', orders: 260 },
    { month: 'Dec', orders: 360 },
  ],
  projects: [
    {
      label: 'jumbo react',
      value: 'jumbo-react',
      color: '#6200EE',
      backgroundColor: '#DDC9FB',
      data: [
        { month: 'Jan', amount: 1000 },
        { month: 'Feb', amount: 850 },
        { month: 'Mar', amount: 1400 },
        { month: 'Apr', amount: 700 },
        { month: 'May', amount: 1100 },
        { month: 'Jun', amount: 900 },
        { month: 'Jul', amount: 1600 },
        { month: 'Aug', amount: 900 },
        { month: 'Sep', amount: 1250 },
        { month: 'Oct', amount: 1000 },
        { month: 'Nov', amount: 1400 },
        { month: 'Dec', amount: 1200 },
      ],
    },
    {
      label: 'Wieldy',
      value: 'wieldy',
      color: '#F5A32F',
      backgroundColor: '#FBE0B9',
      data: [
        { month: 'Jan', amount: 800 },
        { month: 'Feb', amount: 850 },
        { month: 'Mar', amount: 1350 },
        { month: 'Apr', amount: 700 },
        { month: 'May', amount: 1100 },
        { month: 'Jun', amount: 900 },
        { month: 'Jul', amount: 1600 },
        { month: 'Aug', amount: 900 },
        { month: 'Sep', amount: 1250 },
        { month: 'Oct', amount: 1000 },
        { month: 'Nov', amount: 1200 },
        { month: 'Dec', amount: 800 },
      ],
    },
    {
      label: 'Drift Angular',
      value: 'drift-angular',
      color: '#FF4081',
      backgroundColor: '#FFBDD4',
      data: [
        { month: 'Jan', amount: 1100 },
        { month: 'Feb', amount: 850 },
        { month: 'Mar', amount: 1400 },
        { month: 'Apr', amount: 800 },
        { month: 'May', amount: 1100 },
        { month: 'Jun', amount: 900 },
        { month: 'Jul', amount: 1200 },
        { month: 'Aug', amount: 900 },
        { month: 'Sep', amount: 1300 },
        { month: 'Oct', amount: 1000 },
        { month: 'Nov', amount: 800 },
        { month: 'Dec', amount: 900 },
      ],
    },
  ],
};
